import purify from "dompurify";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { HookBannerWrapper } from "app/common/TouchHookBanner/StyledTouchHookBanner";
import { openHooksModalV5 } from "app/services/ModalService";
import { allTrackers } from "app/services/track/track";

export const TouchHookBanner = () => {
    const { translate } = useTranslate();

    const handleButtonClick = () => {
        allTrackers.dispatchTrackEvent("pro hooks 2.0", "click", `contact us/WebsiteContent`);
        void openHooksModalV5("ContactUs", undefined, "contact us/WebsiteContent", "GetLoading");
    };

    return (
        <HookBannerWrapper data-automation="touch-hook-banner">
            <Stack gap="8px">
                <Text
                    fontVariant="caption"
                    color={colorsPalettes.indigo[200]}
                    textTransform="uppercase"
                >
                    {translate("touch.hook.premium")}
                </Text>
                <Text
                    fontVariant="h4"
                    color={colorsPalettes.carbon[0]}
                >
                    {translate("touch.hook.title")}
                </Text>
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.midnight[50]}
                    dangerouslySetInnerHTML={{
                        __html: purify.sanitize(translate("touch.hook.description")),
                    }}
                />
            </Stack>
            <IconButton
                iconName="spark"
                type="trial"
                isHover={true}
                onClick={handleButtonClick}
                data-automation="touch-hook-banner-cta"
            >
                {translate("talk.to.sales.btn")}
            </IconButton>
        </HookBannerWrapper>
    );
};
